import {API} from "aws-amplify";

/**
 * Fetch guest logs from the API
 * @param {Object} params - Request parameters
 * @param {string} params.guest_id - Guest ID
 * @param {number} [params.start_timestamp] - Timestamp for continuing from a previous page
 * @param {number} [params.size=50] - Number of logs to fetch
 * @returns {Promise<Array>} - Array of guest logs
 */
export const fetchGuestLogs = async (params) => {
  try {
    const response = await API.get("ensoAPI", `/guestlogs?${params}`);
    return response;
  } catch (err) {
    throw err;
  }
};
